import { API_BASE_URL } from '../index'

import { api } from './index.api'
import { config } from '../json/config.json'

function randomString(len, charSet) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    var randomString = '';
    for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz,randomPoz+1);
    }
    return randomString;
}
var state = randomString(64)
var authorizeUrl = config[window.location.hostname].authorizeUrl
var clientId = config[window.location.hostname].clientId
var scope  = config[window.location.hostname].scope
var responseType = config[window.location.hostname].responseType
var redirectUri = config[window.location.hostname].redirectUri

var completeUrl = authorizeUrl + "client_id=" + clientId +"&scope="+ scope +"&response_type=" +responseType + "&redirect_uri="+redirectUri +"&state=" + state

export const triggerSSO = (selectedLanguage, path = 'saml/auth-request') => {
  saveSelectedDetailsInSession(selectedLanguage)
  window.location.replace(API_BASE_URL + path)
}

export const triggerHCPSSO = (selectedLanguage) => {
	saveSelectedDetailsInHCPSession(selectedLanguage)
	
    window.location.replace(completeUrl)
}

const saveSelectedDetailsInSession = selectedLanguage => {
  sessionStorage.setItem('loginBySSO', true)
  // sessionStorage.setItem('userCountry', JSON.stringify(selectedCountry));
  sessionStorage.setItem('userLanguage', selectedLanguage)
}

const saveSelectedDetailsInHCPSession = selectedLanguage => {
	  sessionStorage.setItem('loginByOAuthSSO', true)
	  // sessionStorage.setItem('userCountry', JSON.stringify(selectedCountry));
	  sessionStorage.setItem('userLanguage', selectedLanguage)
	}



// WEBPACK FOOTER //
// ./src/mi-app/InitiateSSO.js